import { type Directive } from "vue";

const POP_STYLE_ID = "__animate-pop_style__";
const AnimationName = "animate-pop-anim";
const CssClass = "animate-pop";

function ensurePopStyles() {
  if (document.getElementById(POP_STYLE_ID)) return;

  const style = document.createElement("style");
  style.id = POP_STYLE_ID;
  style.textContent =
    `@keyframes ` +
    AnimationName +
    ` {
  0%   { transform: scale(1); }
  40%  { transform: scale(1.3); }
  100% { transform: scale(1); }
}

.` +
    CssClass +
    ` {
  animation: ` +
    AnimationName +
    ` 0.4s ease-out;
}`;
  document.head.appendChild(style);
}

function triggerPop(el: HTMLElement) {
  el.classList.remove(CssClass);
  void el.offsetWidth;
  el.classList.add(CssClass);
  el.addEventListener(
    "animationend",
    (e: AnimationEvent) => {
      if (e.animationName === AnimationName) el.classList.remove(CssClass);
    },
    { once: true }
  );
}

const animatePop: Directive = {
  mounted() {
    ensurePopStyles();
  },
  updated(el, binding) {
    if (binding.value !== binding.oldValue) triggerPop(el);
  },
};

export default animatePop;
